import { Component, HostListener, OnDestroy, InjectionToken, inject } from '@angular/core';
import { Subject } from 'rxjs';

export const SSR_IS_MOBILE = new InjectionToken<boolean>('SSR_IS_MOBILE', {
  providedIn: 'root',
  factory: () => false,
});

enum DEVICE_TYPES {
  DESKTOP = 'DESKTOP',
  MOBILE = 'MOBILE',
  TAB = 'TAB'
}

@Component({
  selector: 'device-detector',
  template: ''
})
export abstract class DeviceDetectorComponent implements OnDestroy {
  private readonly ssrIsMobile: boolean = inject(SSR_IS_MOBILE);
  isMobile = false;
  isDesktop = false;
  isTab = false;
  sDevice: DEVICE_TYPES = DEVICE_TYPES.DESKTOP;
  device = new Subject<string>();
  isAndroid = false;
  isiPhone = false;
  constructor() {
    this.setDeviceDetector();
    this.getMobileOperatingSystem();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.setDeviceDetector();
  }


  setDeviceDetector() {
    this.isMobile = false;
    this.isDesktop = false;
    this.isTab = false;
    if (typeof window === 'undefined') {
      this.isMobile = this.ssrIsMobile;
      this.isDesktop = !this.ssrIsMobile;
      this.sDevice = this.ssrIsMobile ? DEVICE_TYPES.MOBILE : DEVICE_TYPES.DESKTOP;
      this.device.next(this.sDevice);
      return;
    }
    if (window.innerWidth < 600) {
      this.isMobile = true;
      this.sDevice = DEVICE_TYPES.MOBILE;
    } else if (window.innerWidth < 992) {
      this.isTab = true;
      this.sDevice = DEVICE_TYPES.TAB;
    } else {
      this.isDesktop = true;
      this.sDevice = DEVICE_TYPES.DESKTOP;
    }
    setTimeout(() => {
      this.device.next(this.sDevice);
    });
  }

  getMobileOperatingSystem() {
    if (typeof window === 'undefined') return;
    const userAgent = navigator.userAgent || navigator.vendor || window['opera'];
    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      this.isAndroid = true; //"Windows Phone"
    }
    if (/android/i.test(userAgent)) {
      this.isAndroid = true;
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window['MSStream']) {
      this.isiPhone = true;
    }
  }

  ngOnDestroy(): void {
    this.device?.unsubscribe();
  }

}
